import { Location } from '@angular/common';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { CacheService } from '../services/cache.service';
import { ConstantsService } from '../services/constants.service';
import { GetPaymentService } from '../services/get-payment.service';
import { UserService } from '../services/user.service';
import { NavigationService } from '../services/navigation.service'; // 2. Import your new service
// import { HelperService } from '../services/helper.service';

@Component({
  selector: 'app-subscriptions',
  templateUrl: './subscriptions.component.html',
  styleUrls: ['./subscriptions.component.scss']
})
export class SubscriptionsComponent implements OnInit, OnDestroy {

  login: boolean = false;
  isPrime: any;
  amount: any;
  previousUrl: string = '';
  constructor(
    public constants: ConstantsService,
    private _location: Location,
    private router: Router,
    private authenticate: CacheService,
    private paymentService: GetPaymentService,
    private userService: UserService,
    private navigationService: NavigationService
    // private helperService:HelperService
  ) { }

  ngOnInit(): void {
    // The section below is commented out because Publift ads need to be removed.
    // this.helperService.addGlobalStyle('.publift-widget-23174194645-container,.publift-widget-23196941527-container { display: none !important}');
    this.paymentService.cast.subscribe((data) => {
      this.isPrime = data.isPrime;
    });
    this.authcall();
  }

  ngOnDestroy(): void {
    // The section below is commented out because Publift ads need to be removed.
    // this.helperService.removeGlobalStyle();
  }

  OnClickClose = () => {
    // Get the previous URL from our service
    this.previousUrl = this.navigationService.getPreviousUrl();
    this.router.navigate([this.previousUrl || '/']);
  }
  public async authcall() {
    // Get current user data from db for get the email and name
    this.authenticate.getAuthUser()
      .then(async (data) => {
        let { login, userName, given_name } = data;
        this.login = login;
        if (this.login) {
          await this.paymentService.getUserData(userName, given_name);
          await this.userService.getUser(false)
            .then(data => {
              if (data.prime) {
                if (data.prime.amount === 50) {
                  this.amount = 50;
                } else if (data.prime.amount === 5) {
                  this.amount = 50;
                } else if (data.prime.amount === 20) {
                  this.amount = 20;
                }
              } else {
                this.amount = 50;
              }
            })
        } else {
          this.amount = 50;
        }
      })
  }
  onClickButton = () => {
    if (this.login) {
      this.router.navigate(['/payment']);
    } else {
      this.router.navigate(['/signup']);
      this.authenticate.fromPricingPage = 'true';
      localStorage['fromPricing'] = JSON.stringify(true)
    }
  }
}
